import { render, staticRenderFns } from "./InviteNewAccount.vue?vue&type=template&id=1bcad296&scoped=true&"
import script from "./InviteNewAccount.vue?vue&type=script&lang=js&"
export * from "./InviteNewAccount.vue?vue&type=script&lang=js&"
import style0 from "./InviteNewAccount.vue?vue&type=style&index=0&id=1bcad296&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcad296",
  null
  
)

export default component.exports